import React from "react";
import { Alert, AlertTitle, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "../context/Internationalization";
import { BILLING_ROUTE } from "../routes";
import StartClubTrialButton from "./StartClubTrialButton";
import { billingActionLabel, formatBillingDate, getBillingPresentation } from "../pages/Billing/billingPresentation";

export default function ClubBillingNotice({ billing, onRefreshBilling }) {
  const { t, lang } = useTranslation();
  const canView = billing.canViewBilling === true;
  const presentation = getBillingPresentation(billing, lang);
  const titleKey = presentation.titleKey || "billing_notice_subscription";
  // Staff without billing permission only see their access level, not financial details.
  const messageKey = canView ? presentation.messageKey : "billing_state_read_only";
  const message = presentation.messageDate
    ? t(messageKey).replace("{date}", presentation.messageDate)
    : t(messageKey);
  const endDate = canView && billing.cancelAtPeriodEnd
    ? formatBillingDate(billing.currentPeriodEnd, lang) : null;
  const startDate = canView && presentation.messageKey === "billing_state_early_signup"
    ? formatBillingDate(billing.freeAccessUntil, lang) : null;
  const trialEnd = canView && presentation.dateFields.includes("trialEnd")
    ? formatBillingDate(billing.trialEnd, lang) : null;

  return (
    <Alert severity={presentation.severity} role="status" aria-label={t(titleKey)}
      action={billing.canManageBilling === true &&
        (billing.canStartLocalTrial || ["checkout", "portal"].includes(billing.nextAction)) ? (
        billing.canStartLocalTrial ? <StartClubTrialButton key={String(billing.clubId)}
          clubId={billing.clubId} onStarted={onRefreshBilling} /> :
        <Button component={Link} to={BILLING_ROUTE} size="small">
          {t(billingActionLabel(billing))}
        </Button>
      ) : null}
      sx={{
        mx: { xs: 2, md: 3 }, mt: 3, fontSize: 14,
        flexWrap: { xs: "wrap", md: "nowrap" },
        "& .MuiAlert-message": { flex: 1, minWidth: 0 },
        "& .MuiAlert-action": {
          p: 0, mr: 0, ml: { xs: 0, md: 2 }, mt: { xs: 1, md: 0 },
          flexBasis: { xs: "100%", md: "auto" }, maxWidth: { xs: "100%", md: "40%" },
          flexDirection: "column", alignItems: "flex-end", alignSelf: "center",
        },
      }}>
      <AlertTitle sx={{ fontSize: 14, fontWeight: 700 }}>{t(titleKey)}</AlertTitle>
      {message}
      {endDate && <div>{t("current_period_ends")}: {endDate}</div>}
      {startDate && <div>{t("billing_starts")}: {startDate}</div>}
      {trialEnd && <div>{t("trial_ends")}: {trialEnd}</div>}
      {billing.canManageBilling !== true && <div>{t("billing_contact_administrator")}</div>}
    </Alert>
  );
}
